module.exports = __webpack_public_path__ + "img/2_2.289ef5c3.jpg";